import React from "react"
import { ContentLink, QBankImage } from "../../@types/CapioWeb/core"
import {
	Property,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { BlockCommonLayout } from "../../utils/layout"
import { WorkHereCard } from "./WorkHereCard"

interface CapioCareerListItem {
	careerHeader: string
	careerLocation: string
	careerPageLink: ContentLink
}

type PageProperty = Property<ContentLink>

interface CapioCareerListBlockProps {
	careerListItems: CapioCareerListItem[]
	heading: StringProperty
	imageBlock: QBankImage
	preamble: StringProperty
	selectedCareerList: PageProperty
	selectedCareerListLinkText: string
}

export const CapioCareerListBlock: React.FC<CapioCareerListBlockProps> = ({
	heading,
	imageBlock,
	preamble,
	careerListItems,
	selectedCareerList,
	selectedCareerListLinkText,
}) => {
	return (
		<BlockCommonLayout heading={heading} description={preamble}>
			<WorkHereCard
				cta={
					selectedCareerList.value?.url &&
					selectedCareerListLinkText && {
						text: selectedCareerListLinkText,
						href: selectedCareerList.value.url,
					}
				}
				image={imageBlock}
				items={careerListItems.slice(0, 4).map((item) => ({
					header: item.careerLocation,
					href: item.careerPageLink.url,
					text: item.careerHeader,
					location: item.careerLocation,
				}))}
			/>
		</BlockCommonLayout>
	)
}
